import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type DaylightImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};

export type DaylightLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

export type DaylightPrimitiveRegistry = {
  Image: ComponentType<DaylightImagePrimitiveProps>;
  Link: ComponentType<DaylightLinkPrimitiveProps>;
};

export type DaylightPrimitiveName = keyof DaylightPrimitiveRegistry;

const Image = ({ imageClassName, priority: _priority, ...props }: DaylightImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });

const Link = ({ children, rel, target, ...props }: DaylightLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );

const registry: DaylightPrimitiveRegistry = { Image, Link };

export function registerComponent<K extends DaylightPrimitiveName>(
  name: K,
  component: DaylightPrimitiveRegistry[K],
) {
  registry[name] = component;
}

export function getComponent<K extends DaylightPrimitiveName>(
  name: K,
): DaylightPrimitiveRegistry[K] {
  return registry[name];
}
